export default __webpack_public_path__ + "images/6b4dc4ca3de78694cad79820b16b9734-investment_small.webp";